/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */
export const durationStep = 25;

export const smallDurationMs = durationStep * 4;

export const mediumDurationMs = durationStep * 14;

export const largeDurationMs = durationStep * 28;
